/**
 * Facet: Accordion - Indicator
 *
 * Implements functionality where changed fields inside accordions cause
 * an indicator to appear next to the accordion label.
 */

(() => {
    let facets = document.querySelector('.js-facets');
    let accordions = document.querySelectorAll('.js-facet-accordion');

    // validate
    if (!facets || !accordions.length) {
        return;
    }

    /**
     * Helper: Get all ancestors
     */
    const getAllAncestors = (item, css_class) => {
        let result = [];
        let ancestor = item.parentElement;
        while (ancestor && !ancestor.isEqualNode(facets)) {
            if (ancestor.classList.contains(css_class)) {
                result.push(ancestor);
            }
            ancestor = ancestor.parentElement;
        }
        return result;
    };

    /**
     * Helper: Get closest ancestor
     */
    const getAncestor = (item, css_class) => {
        const result = getAllAncestors(item, css_class);
        if (result.length) {
            return result[0];
        }
        return null;
    };

    function truncateIndicatorText(text) {
        if (
            !time_months_long ||
            !time_months_short ||
            time_months_long.constructor !== Array ||
            time_months_short.constructor !== Array ||
            time_months_long.length !== 12 ||
            time_months_short.length !== 12
        ) {
            return text;
        }

        // Replace every permutation of a list of consecutive months into a shorter format
        // For example 'January, February' will become 'Jan-Feb'
        // ---
        // i = index of start month
        // j = index of end month
        for (let i = 0; i < 11; i++) {
            for (let j = 11; j > i; j--) {
                let replace = time_months_long.slice(i, j + 1).join(', ');
                // console.log(replace);
                text = text.replace(
                    replace,
                    time_months_short[i] + '-' + time_months_short[j]
                );
            }
        }

        // Replace long month names with short names
        for (let i = 0; i < 12; i++) {
            text = text.replace(time_months_long[i], time_months_short[i]);
        }

        return text;
    }

    function addIndicator(accordion) {
        // console.log('Adding indicator to accordion...');

        let button = accordion.querySelector('.js-facet-accordion-button');

        if (!button) {
            return;
        }

        // console.log('... Button was found!');
        // console.log(button);

        let inputs = accordion.querySelectorAll('.js-facet-input');

        let selected_count = 0;
        let selected_labels = [];

        inputs.forEach((input) => {
            if (!input.checked) {
                return;
            }

            selected_count++;

            const text = input.parentElement.querySelector(
                '.js-facet-label-text'
            );

            if (!text) {
                return;
            }

            selected_labels.push(text.innerText.trim());
        });

        // Update aria-description
        // -----------------------

        const description = button.getAttribute('data-description-modified');
        button.setAttribute(
            'aria-description',
            description + ', ' + selected_labels.join(', ')
        );
        button.classList.add('-fields-modified');

        // Update visible indicator text
        // -----------------------------

        let indicator = accordion.querySelector(
            '.js-faceted-search-accordion-indicator'
        );

        if (!indicator) {
            return;
        }

        const selected_labels_unique = [...new Set(selected_labels)];

        const indicator_text = truncateIndicatorText(
            selected_labels_unique.join(', ')
        );

        if (indicator_text !== '' && indicator_text.length < 20) {
            indicator.innerHTML = indicator_text;
        } else {
            indicator.innerHTML = '(' + selected_count + ')';
        }
    }

    function removeIndicator(accordion) {
        // console.log('Removing indicator from accordion...');

        let button = accordion.querySelector('.js-facet-accordion-button');
        if (button) {
            button.setAttribute('aria-description', '');
            button.classList.remove('-fields-modified');
        }

        let indicator = accordion.querySelector(
            '.js-faceted-search-accordion-indicator'
        );
        if (indicator) {
            indicator.innerHTML = '';
        }
    }

    function updateIndicator(accordion) {
        // console.log('Updating indicator state of accordion...');

        let fields_modified = false;

        let checkboxes = accordion.querySelectorAll('input[type=checkbox]');
        if (checkboxes.length) {
            checkboxes.forEach((checkbox) => {
                if (checkbox.checked) {
                    fields_modified = true;
                }
            });
        }

        if (fields_modified) {
            addIndicator(accordion);
        } else {
            removeIndicator(accordion);
        }
    }

    function checkboxChanged(e) {
        let accordion = getAncestor(e.currentTarget, 'js-facet-accordion');
        if (e.currentTarget.checked) {
            addIndicator(accordion);
        } else {
            updateIndicator(accordion);
        }
    }

    accordions.forEach((accordion) => {
        let checkboxes = accordion.querySelectorAll('input[type=checkbox]');
        if (checkboxes.length) {
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', checkboxChanged);
            });
        }
        updateIndicator(accordion);
    });
})();
